import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import userService from "../services/user.service";
import { Uservalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";

const Usersmartevent = (props) => {
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const ref = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");

  const [user_id, setUserid] = useState();

  //form initial value
  const formik = useFormik({
    initialValues: {
      user_id: "",
      user_name: "",
      user_status: "",
    },
    validationSchema: Uservalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 1));
      /*  resetForm({ values: '' }) */
    },
  });
  //use effects
  useEffect(() => {
    setUserid(searchParams.get("user_id"));
    if (searchParams.get("user_id")) {
      setEventname("view");
      getUser(searchParams.get("user_id"));
    } else {
      setEventname("create");
    }
  }, []);

  //current event
  const userEvent = (eventname, value) => {
    if (value) {
      getUser(value);
    }
    setEventname(eventname);
  };

  //get user
  const getUser = (value) => {
    setIsLoaded(true);
    userService
      .getUser(value)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            user_id: data.user_id,
            user_name: data.user_name,
            user_status: data.user_status == null ? "" : data.user_status,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  //create user
  const createUser = () => {
    userService
      .createUser(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          navigate("/usersmarttable");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //update user
  const updateUser = () => {
    userService
      .updateUser(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          userEvent("view");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //delete user
  const deleteUser = (value) => {
    userService
      .deleteUser(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          navigate("/usersmarttable");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  // Call user clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="container">
        {/*  container */}
        <div className="user-container">
          {/* form container */}
          <div className="card shadow-sm border-0 ">
            <div className="card-body ">
              <div className="d-flex">
                <h5 className="card-title p-0 m-0 me-auto">User</h5>
                {eventname == "create" ? (
                  <></>
                ) : (
                  <div>
                    <div className="dropdown">
                      <a
                        className="btn  btn-link"
                        href="#"
                        role="button"
                        id="usereventdropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="usereventdropdownMenuLink"
                      >
                        <li>
                          <a
                            onClick={() => {
                              userEvent("edit");
                            }}
                            className="dropdown-item"
                          >
                            Edit
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => userEvent("delete")}
                            className="dropdown-item"
                          >
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/*  profile section */}
                  <div className="col-md-4">
                    <label htmlFor="user_id" className="form-label">
                      Id
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Enter Id"
                        id="user_id"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "edit"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("user_id")}
                      />
                    </div>
                    <div>
                      {formik.touched.user_id && formik.errors.user_id ? (
                        <div className="error">{formik.errors.user_id}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-5">
                    <label htmlFor="user_name" className="form-label">
                      Username
                    </label>
                    <div className="input-group col-md-6">
                      <input
                        className="form-control"
                        placeholder="Enter username"
                        id="user_name"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("user_name")}
                      />
                    </div>
                    <div>
                      {formik.touched.user_name && formik.errors.user_name ? (
                        <div className="error">{formik.errors.user_name}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="user_status" className="form-label">
                      status
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="user_status"
                        {...formik.getFieldProps("user_status")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        aria-label="user_status"
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div>
                      {formik.touched.user_status &&
                      formik.errors.user_status ? (
                        <div className="error">{formik.errors.user_status}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </form>
              <div className="pt-2 pb-2">
                {eventname === "create" ? (
                  <>
                    <button
                      disabled={!formik.isValid}
                      onClick={() => createUser()}
                      className="btn btn-primary me-2"
                    >
                      Create
                    </button>
                    <button
                      onClick={formik.handleReset}
                      className="btn btn-secondary"
                    >
                      Clear
                    </button>
                  </>
                ) : eventname === "edit" ? (
                  <>
                    {" "}
                    <button
                      onClick={() => updateUser()}
                      className="btn btn-primary me-2"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => userEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : eventname === "delete" ? (
                  <>
                    <button
                      onClick={() => deleteUser(formik.values.user_id)}
                      className="btn btn-danger me-2 "
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => userEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    {/* <button onClick={() => navigate('/userloyee')} className='btn btn-primary' >Back</button> */}
                  </>
                )}
              </div>
            </div>
          </div>
          {/*  loader and error handler */}
          {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
          <Toastmessage ref={ref} />
          {/* <Alertmsg ref={ref}/> */}
        </div>
      </div>
    );
  }
};

export default Usersmartevent;
